module.exports = __webpack_public_path__ + "static/media/633afeec-2ea7-4b73-a13b-068e9f23cacf.0dd81860.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/633afeec-2ea7-4b73-a13b-068e9f23cacf.jpg
// module id = 824
// module chunks = 0